<template>
    <div>
        <div v-if="is_super_admin">
        <div style="padding: 0px 16px;">
            <el-button plain type="primary" @click="addRecharge" size="small" icon="el-icon-plus">新增会员充值规则</el-button>
        </div>

        <div style="padding: 10px 16px;">
            <el-table
                :data="lVipPointsList"
                style="width: 100%;border-color:'#606266'"
                :default-sort = "{prop: 'date', order: 'descending'}"
                :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
                :cell-style="{color: '#666',fontSize:'14px'}"
                border
            >
                <el-table-column type="expand" fixed>
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="demo-table-expand">
                            <el-row :gutter="24">
                                <el-col :span="12">
                                    <el-form-item label="规则ID:">
                                        <el-tag>{{ props.row.vip_recharge_id }}</el-tag>
                                    </el-form-item>
                                </el-col>
                                
                                <el-col :span="12">
                                    <el-form-item label="充值金额:">
                                        <el-tag type="success">{{ props.row.last_recharge_money }}</el-tag>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-divider style="margin-top: 100px;"><i class="el-icon-s-ticket"></i></el-divider>
                            <el-row :gutter="0" v-for="(couponInfo, couponId) in props.row.coupon_info" :key=couponId.key>
                                <el-col :span="3">
                                    <el-form-item label="优惠券ID:">
                                        <el-tag type="warning" size="mini">{{ couponId }}</el-tag>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="3">
                                    <el-form-item label="优惠券数量:">
                                        <el-tag type="warning" size="mini">{{ couponInfo.coupon_num }}</el-tag>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="3">
                                    <el-form-item label="有效天数:">
                                        <el-tag type="warning" size="mini">{{ couponInfo.coupon_valid_days }}</el-tag>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="3">
                                    <el-form-item label="优惠券名称:">
                                        <el-tag type="warning" size="mini">{{ couponInfo.coupon.coupon_name }}</el-tag>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="3">
                                    <el-form-item label="抵扣模式:">
                                        <template>
                                            <el-tag size="mini" type="success" v-if="couponInfo.coupon.coupon_mode == 1">现金抵扣</el-tag>
                                            <el-tag size="mini" v-else>折扣方式</el-tag>
                                        </template>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="3">
                                    <el-form-item label="抵扣金额:">
                                        <el-tag size="mini" type="warning">{{ couponInfo.coupon.coupon_amount }}</el-tag>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="3">
                                    <el-form-item label="折扣率:">
                                        <el-tag size="mini" type="warning">{{ couponInfo.coupon.coupon_discount }}</el-tag>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </template>
                </el-table-column>

                <el-table-column
                    fixed
                    align="center"
                    prop="vip_recharge_id"
                    label="规则ID"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    fixed
                    align="center"
                    prop="last_recharge_money"
                    label="充值金额"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    align="center"
                    label="操作"
                    width="150px"
                >
                    <template slot-scope="scope">
                        <el-button round icon="el-icon-delete" type="danger" size="small" @click="deleteFunc(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
                
            </el-table>
        </div>
        

        <el-dialog :visible.sync="bShowDialog" :fullscreen="bShowFullscreen" :before-close="this.$dialog_close" :show-close="false">
            <div slot="title" class="dialog-title">
                <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ sDialogName }}</span>
                <el-button icon="el-icon-close" class='dialog-title-button' @click="bShowDialog = false"></el-button>
                <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="bShowFullscreen = !bShowFullscreen"></el-button>
            </div>

            <el-form :model="dFromData" ref="dFromData" labeel-width="100px" @class="demo-dFromData">
                <el-row :gutter="24">
                    <el-col :span="24">
                        <el-form-item label="最低充值金额" prop="last_recharge_money">
                            <el-input-number v-model="dFromData.last_recharge_money" :min="0" :step="10" label="充值金额" ></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row v-for="dCoupon in lCouponInfo" :key="dCoupon.key">

                    <el-col :span="8">
                        <el-form-item label="选择优惠券" prop="coupon_id">
                            <el-select v-model="dCoupon.coupon_id" clearable  placeholder="请选择优惠券">
                                <el-option
                                    v-for="item in lCouponTypeList"
                                    :key="item.coupon_type_id"
                                    :value="item.coupon_type_id"
                                    :label="item.coupon_name"
                                > 
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="优惠券个数" prop="coupon_num">
                            <el-input-number v-model="dCoupon.coupon_num" :min="0" :step="1" label="优惠券个数" ></el-input-number>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="有效天数" prop="coupon_valid_days">
                            <el-input-number v-model="dCoupon.coupon_valid_days" :min="0" :step="10" label="有效天数" ></el-input-number>
                            <el-button @click.prevent="removeCoupon(dCoupon)" style="margin-left: 10px;">删除</el-button>
                        </el-form-item>
                        
                    </el-col>
                </el-row>
            </el-form>
            <el-button type="primary" @click="addCouponInfo" size="small" icon="el-icon-plus" plain style="width: 100%;">新增一个优惠券信息</el-button>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="cancelFunc">取 消</el-button>
                <el-button type="primary" @click="defineFunc">确 定</el-button>
            </div>
        </el-dialog>
        </div>
        <div v-else>
            <div style="text-align: center;">
                <div style="margin-top: 0px;">
                <img src="../../assets/permission_denied.png">
                <div style="margin-top: 20px;">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VipPointsSystem",
    data(){
        return {
            sDialogName: '',
            bShowDialog: false,
            sBtnName: '',
            bShowFullscreen: false,
            bRequestType: true,
            // 优惠券类型列表
            lCouponTypeList: [],
            dFromData: {},

            lCouponInfo: [{}],

            lVipPointsList: [],
            is_super_admin: false,

        }
    },

    mounted(){
        // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
        let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
        if (isSuperAdmin == "false") {
            this.is_super_admin = false
            return
        } else {
        this.is_super_admin = true
        }
        this.getRechargeList();

    },

    methods: {
        // 获取当前规则
        async getRechargeList(){
            let res = await this.$axios.get('/api/vip_recharge/');
            this.lVipPointsList = res.data;
            console.log(this.lVipPointsList)
        },
        

        // 请求所有的优惠券类型
        async getAllCouponType(){
            let url = '/api/coupon_type/'
            let res = await this.$axios.get(url)
            console.log(res)
            this.lCouponTypeList = res.data
            console.log(this.lCouponTypeList)
        },

        // 新增会员充值规则事件
        addRecharge(){
            this.getAllCouponType()
            this.lCouponInfo = [{}]
            this.dFromData = {}
            this.bShowDialog = true
            this.sDialogName = '新增会员充值规则'
            this.sBtnName = '新增'
            this.bShowFullscreen = false
        },

        // 取消事件
        cancelFunc(){
            this.bShowDialog = false
        },

        // 确定事件
        async defineFunc(){
            // 判断coupon_id是否有重复的
            let lCouponInfoNum = []
            for(let i = 0; i < this.lCouponInfo.length; i++){
                let dCoupon = this.lCouponInfo[i]
                if(lCouponInfoNum.indexOf(dCoupon.coupon_id) == -1){
                    lCouponInfoNum.push(dCoupon.coupon_id)
                }else{
                    this.$message.error('优惠券类型不能重复')
                    return
                }
            }

            // 校验数据
            let lCouponInfoTemp = []
            for(let i = 0; i < this.lCouponInfo.length; i++){
                let dCoupon = this.lCouponInfo[i]
                if(dCoupon.coupon_id == null){
                    this.$message.error('请选择优惠券')
                    return
                }
                if(dCoupon.coupon_num == null){
                    this.$message.error('请输入优惠券个数')
                    return
                }
                if(dCoupon.coupon_valid_days == null){
                    this.$message.error('请输入有效天数')
                    return
                }
                lCouponInfoTemp.push(dCoupon)
            }

            if(this.dFromData.last_recharge_money == null){
                this.$message.error('请输入最低充值金额')
                return
            }
            
            let couponInfo = {}
            
            // 修改数据格式
            for (let i = 0; i < lCouponInfoTemp.length; i++) {
                let dCoupon = this.lCouponInfo[i]
                couponInfo[dCoupon.coupon_id] = {
                    coupon_num: dCoupon.coupon_num,
                    coupon_valid_days: dCoupon.coupon_valid_days
                }
            }

            let requestData = {
                coupon_info: couponInfo,
                last_recharge_money: this.dFromData.last_recharge_money
            }

            let url = '/api/vip_recharge/'
            let res = await this.$axios.post(url, requestData)
            this.requestWaring(res)
        },

        // 请求警告
        requestWaring(res){
            console.log(res)

            if (res.status === 201 || res.status === 200){
                this.$message({
                    message: '操作成功',
                    type: 'success'
            })
            this.bShowDialog = false
            this.getRechargeList()
            
            } else {
                this.$message({
                    message: '操作失败',
                    type: 'error'
                })
            }
        },

        // 动态在表单里面新增优惠券的信息
        addCouponInfo(){
            console.log(this.lCouponInfo)
            this.lCouponInfo.push({})
        },

        // 删除表单里面的优惠券
        removeCoupon(item){
            let index = this.lCouponInfo.indexOf(item)
            if (index !== -1){
                this.lCouponInfo.splice(index, 1)
            }
        },

        // 删除积分配置
        deleteFunc(row){
            var _this = this
            this.$confirm('此操作将永久删除该消息', '删除消息警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                _this.$axios.delete('/api/vip_recharge/' + row.vip_recharge_id + '/').then(
                function(res){_this.$message({type: 'success', message: '删除成功!'});
                _this.getRechargeList()})
            }).catch(() => {
                _this.$message({type: 'info',message: '已取消删除'});          
            });
        },
    },
}
</script>

<style>
  /* .demo-table-expand {
    font-size: 0;
  } */
  .demo-table-expand label {
    /* width: 90px; */
    color: #99a9bf;
    
  }
  /* .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  } */
</style>